module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n            " + _vm._s(_vm.type) + "\n        ")]), _vm._v(" "), _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                        Betalt\n                    ")]) : _c('span', [_vm._v("\n                        Ikke betalt\n                    ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.selectedProjectType) ? _c('div', [_c('minuba-budget-single-projects', {
    attrs: {
      "rows": _vm.selectedProjectType.projects,
      "type": _vm.selectedProjectType.name
    }
  })], 1) : _c('div', [_vm._v("\n            Vælg en opgavetype for at se de enkelte opgaver her\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-798d4fd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/minubaBudgetProjectTypesLineTypes.vue
// module id = 906
// module chunks = 0